<template>
  <div class="ty-main">
    <div class="ty-content">
      <div class="ty-card ty-cont">
        <div>
          <el-radio-group v-model="timeRadio" @change="timeRadioChange">
            <el-radio-button label="近7天"></el-radio-button>
            <el-radio-button label="近30天"></el-radio-button>
          </el-radio-group>
          <el-date-picker
            class="ml20"
            v-model="scopeDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :default-value="Date.now() - 30 * 24 * 3600 * 1000"
          >
          </el-date-picker>
          <el-button class="ml20 er dsfdi" type="primary" @click="onSearch">查询</el-button>
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          content="风险预警只监控文本消息"
          placement="top-end"
        >
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <div class="ty-card" v-loading="loading">
        <echart :yData="yData" :xData="xData" :echartTitle="echartTitle"></echart>
      </div>
      <div class="ty-card" v-loading="loading02">
        <bar :yData="wordNum" :xData="wordList"></bar>
      </div>
      <div class="ty-card" ref="warnTable">
        <span class="wen">风险列表</span>
        <span class="zi">敏感词列表</span>
        <el-button class="mb20 fr" type="primary" size="medium" v-auth="['warnExport']" @click="getData1"
          >导出列表</el-button
        >
        <el-table id="educe-table" :data="tableData" style="width: 100%;" max-height="520">
          <el-table-column prop="date" label="日期" fixed width="150">
          </el-table-column>
          <template v-for="(item, index) in cloumns">
            <el-table-column :key="index" :prop="item.prop" :label="item" width="180px;">
              <template slot-scope="scope">
                <el-button
                style="color: black;"
                  type="text"
                  @click="checkDate(scope.row.date, scope.column.label)"
                  v-if="scope.row.value[index] !== 0"
                >
                  <div class="sdfas">{{ scope.row.value[index] }}</div></el-button
                >
                <span style="color: #204A9E;" v-else>-</span>
              </template>
            </el-table-column>
          </template>
          <template #empty>
            <el-empty v-loading="loading04"></el-empty>
          </template>
        </el-table>
      </div>
      <div class="ty-card">
       <span class="wen">风险详情</span>
        <span class="zi">敏感词详情</span>
        <el-form :inline="true" :model="searchForm" onsubmit="return false;" style="margin-top: 20px;">
          <el-form-item label="发送人-员工:">
            <el-input v-model="name" placeholder="请选择员工" @focus="openSelectDialog" clearable @clear="setValueNull"></el-input>
          </el-form-item>

          <el-form-item label="发送人-客户:">
            <el-input v-model="customer" placeholder="请输入客户名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="dsfdi" type="primary" @click="search">查询</el-button>
          </el-form-item>
          <div class="fr">
            <el-button type="primary" size="medium" v-auth="['operating']" @click="getChat1"
              >导出列表</el-button
            >
          </div>
        </el-form>
        <el-table id="ed-table" :data="tableList" element-loading-text="数据加载中" fixed style="width: 100%;" max-height="500">
          <el-table-column label="日期" fixed min-width="194">
            <template slot-scope="scope">
              <span>{{ scope.row.time ? scope.row.time : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="form_name" label="发送人" min-width="280">
           <template slot-scope="scope">
            <div v-if="scope.row.form_name !== null && scope.row.user_data === '' ">
              <el-popover
                v-if="scope.row.form_name.length >= 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.form_name}}
                  <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
                </div>
                <span slot="reference" style="color: #303133;">{{scope.row.form_name | ellipsis}}
                  <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
                </span>
              </el-popover>
              <span v-else>{{scope.row.form_name}}
                <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
              </span>
            </div>
            <div v-else-if="scope.row.user_data">
                <span>{{scope.row.form_name}}</span>
                <span v-if="scope.row.user_data[scope.row.form_id].type === 2 && scope.row.user_data[scope.row.form_id].remarks !== '' " class="corp-text">@{{ JSON.parse(scope.row.user_data[scope.row.form_id].remarks).corp_name }}</span>
                <span v-else-if="scope.row.user_data[scope.row.form_id].type === 2 && scope.row.user_data[scope.row.form_id].remarks === ''" class="wx-text">@微信</span>
            </div>
            <span v-else>-</span>
          </template>
       </el-table-column>
       <el-table-column prop="departmen" label="部门" min-width="220">
         <template slot-scope="scope">
           <span v-if="scope.row.departmen">{{ scope.row.departmen }}</span>
           <span v-else>-</span>
         </template>
       </el-table-column>
          <el-table-column prop="key_word_data.key_word_val" label="敏感词" min-width="180">
            <template slot-scope="scope">
            <div v-if="scope.row.key_word_data.key_word_val.length > 0">
              <el-popover
                v-if="scope.row.key_word_data.key_word_val.length > 20"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.key_word_data.key_word_val}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.key_word_data.key_word_val | ellipsisss}}</span>
              </el-popover>
              <span v-else>{{scope.row.key_word_data.key_word_val}}</span>
            </div>
            <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column prop="key_word_data.key_word_num" label="敏感词个数" min-width="130">
            <template slot-scope="scope">
            <span >{{ scope.row.key_word_data.key_word_num }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="详情" min-width="600">
            <template slot-scope="scope">
            <div v-if="scope.row.content.length > 0">
              <span style="color: rgba(0, 0, 0, 0.45);margin-right: 5px;">[{{ scope.row.message }}]</span>
              <span v-if="scope.row.message === '会话记录'">{{JSON.parse(scope.row.content).title | ellipsissss}}聊天记录</span>
              <span v-else>
                <span v-if="scope.row.content.length <= 30" v-html="strMark(scope.row.content.slice(0, 30), scope.row.key_word_data.key_word_val)"></span>
                <span v-else v-html="strMark(scope.row.content.slice(0, 30) + '...', scope.row.key_word_data.key_word_val)"></span>
              </span>
            </div>
            <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="action" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
<!--              <el-button type="text" v-auth="['operating']" @click="chatDetail(scope.row.msg_id, scope.row.key_word_data.key_word_val)"-->
<!--                >对话详情</el-button-->
<!--              >-->
              <el-button type="text"  @click="chatDetail(scope.row.msg_id, scope.row.key_word_data.key_word_val)"
              >对话详情</el-button
              >
            </template>
          </el-table-column>
          <template #empty>
            <el-empty v-loading="loading01"></el-empty>
          </template>
        </el-table>
        <p class="more-line" v-if="tableList.length > 0">
          <el-button class="weyqui" type="text" :disabled="isLoadOver" @click="listMore">
            {{ isLoadOver ? '已加载全部' : '加载更多' }} </el-button>
            <img v-if="isLoadOver === false" src="../../assets/images/xia.png" width="12" />
        </p>
      </div>
    </div>
    <el-dialog title="对话详情" :visible.sync="dialogVisible" width="650px" :show-close="true">
      <p class="more" v-if="msgId" style="">
        <template v-if="msgId">
          <div style="padding-left: 10px;padding-right: 30px;">
            <chat :msgId="msgId" :associative="associative" :isMask="associative ? false : true" :fsdfgy="dasdas"></chat>
          </div>
        </template>
      </p>
      <p v-else>暂无数据</p>
    </el-dialog>

    <!-- 选择员工 -->
    <el-dialog title="选择员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px" @open="clear">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never" style="border-right: 1px solid #D8DCE1;">
            <el-input
              class="filter-input"
              placeholder="请输入人员名称"
              v-model="filterText"
              @input="dfhuh"
              size="small"
              @clear="gdfgf"
              clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div v-if="treeData01.length > 0 && treeData02.length === 0">
            <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              auto-expand-parent
              :default-checked-keys="peoples"
              lazy
              :check-strictly="true"
              @check-change="getChecked">
                <span class="custom-tree-node" slot-scope="{ data, node }">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img imgleft" src="../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    {{ data.label }}<span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-listss" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
          <div>已选择的员工</div>
            <ul class="infinite-list">
              <li v-for="item in checkedDimission" :key="item.id">
                <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
               </div>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="close">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled01" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>

    <!-- 选择敏感词 -->
    <el-dialog
      title="敏感词"
      :show-close="false"
      :visible.sync="departmentShow3"
      width="30%">
      <el-checkbox-group v-model="checkList" @change="getCode">
        <el-checkbox
        v-for="item in departmentData"
        :label="item.id"
        :key="item.id"
        >{{item.name}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ewqio">取 消</el-button>
        <el-button type="primary" @click="hruwih">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Echart from '../../components/echart'
import Bar from '../../components/bar'
import chat from '../../components/chat'
import { ellipsis, ellipsissss } from '../../utils/filters.js'
import { apiUrl } from '@/config/constant'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
  components: {
    Echart,
    Bar,
    chat
  },
  data() {
    this.keywords = []
    return {
      ellipsis,
      ellipsissss,
      //  apiUrl: 'http://chatdata.test.api.tyunai.cn',
      pickerMinDate: '',
      pickerOptions: {
        onPick: (obj) => {
            this.pickerMinDate = new Date(obj.minDate).getTime()
        },
        disabledDate: (time) => {
            if (this.pickerMinDate) {
                const day1 = 180 * 24 * 3600 * 1000
                const maxTime = this.pickerMinDate + day1
                const minTime = this.pickerMinDate - day1
                return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000
            } else {
                return time.getTime() > Date.now() + 0 * 24 * 3600 * 1000
            }
        }
      },
      apiUrl,
      isSelectDialog: false,
      treeData: [],
      arr: [],
      arre: [],
      dasdas: 1,
      checkedDimission: [],
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'isHasChildren'
      },
      loading: false,
      loading01: false,
      loading02: false,
      loading04: false,
      departmentProps: {
        children: 'child',
        label: 'label',
        value: 'value',
        disabled: 'is_show'
      },
      departmentShow3: false,
      departmentData: [],
      checkList: [],
      checke_id: [],
      id: [],
      depapart_id: [],
      affirmRate: [],
      radio: '确认服务比率',
      echartTitle: ['风险趋势', '敏感词报警趋势'],
      yData: [],
      xData: [],
      content: '',
      wordList: [],
      wordNum: [],
      automatic: false,
      key_list: [],
      scopeDate: [],
      disabled01: true,
      timeRadio: '近7天',
      tableData: [],
      tableList: [],
      cloumns: [],
      analysis: [],
      searchForm: {},
      startDate: '',
      endDate: '',
      startDate1: '',
      endDate1: '',
      loadDate: '',
      page: 1,
      msgId: '',
      key_id: '',
      treeData01: [],
      treeData02: [],
      dialogVisible: false,
      isLoadOver: true,
      asLoadOver: false,
      exportDatas: {},
      f: [],
      h: {},
      words: '',
      name: '',
      customer: '',
      key_words: '',
      word_list: [],
      message_type: [],
      peoples: []
    }
  },
  mounted() {
    this.startDate = this.$moment()
      .subtract('days', 7)
      .format('YYYY-MM-DD')
    this.endDate = this.$moment()
      .subtract(1, 'day')
      .format('YYYY-MM-DD')
    this.getList()
    this.getRisk()
    this.getData()
    this.sfhusi()
    this.selectChange()
    this.getChat()
  },
  watch: {
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.parent_id = 0
        this.sfhusi()
      }
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled01 = false
      } else {
        this.disabled01 = true
      }
    }
  },
  methods: {
    loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 1200)
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.treeData01 = res.return_data
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          res.return_data = [{ isDepartment: true }]
          this.treeData01 = res.return_data
        } else {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    getList() {
      this.loading = true
      this.$api
        .post('/api/system/search/risk/trend', {
          start_date: this.startDate,
          end_date: this.endDate
        })
        .then(res => {
          const xData = []
          const yData = []
          for (const key in res) {
              xData.push(key)
              yData.push(res[key])
          }
          xData.forEach(k => {
            this.xData.push(k.slice(5, 10))
          })
          yData.forEach(p => {
            this.yData.push(p)
          })
          this.loading = false
        })
    },
    getRisk() {
      this.loading02 = true
      const wordList = []
      const wordNum = []
       this.$api
          .post('/api/system/search/risk/ranking', {
            start_date: this.startDate,
            end_date: this.endDate
          })
          .then(res => {
            this.h = res
            for (const key in res) {
              // alert(res[key].num)
                wordNum.push(res[key].name)
                wordList.push(res[key].num)
            }
            // console.log(wordList)
            // console.log(wordNum)
            wordList.forEach(k => {
              this.wordList.push(k)
            })
            wordNum.forEach(p => {
              this.wordNum.push(p)
            })
            this.loading02 = false
          })
    },
    getData() {
      this.loading04 = true
      this.$api
        .post('/api/system/search/risk/ranking/data', {
          start_date: this.startDate,
          end_date: this.endDate,
          page: this.page
        })
        .then(res => {
          const tableData = []
          let cloumns = []
          let itemLength = 0
          Object.keys(res.data).forEach((v, n) => {
            const nextItem = res.data[v]
            const valueList = []
            // const key_id = []
            Object.keys(nextItem).forEach((k, n) => {
              cloumns.push({
                title: nextItem[k].name,
                prop: `data${n}`,
                key_id: nextItem[k].key_id
              })
              valueList.push(nextItem[k].num)
              itemLength = Object.keys(nextItem).length
            })
            cloumns = cloumns.slice(0, itemLength)
            tableData.push({
              date: v,
              value: valueList
            })
        })
        this.cloumns = Object.values(res.key_word)
        this.word_list = res.key_data
        this.tableData = tableData
        this.loading04 = false
      })
    },
    getData1() {
      // this.loading04 = true
      this.$api
        .post('/api/system/search/risk/ranking/data/excel1', {
          start_date: this.startDate,
          end_date: this.endDate,
          page: this.page
        })
        .then(res => {
          this.$message({
            message: '导出的文件请到菜单栏中的【下载中心】去下载',
            type: 'success'
          })
        })
    },
    getChat() {
      if (!this.startDate1) this.startDate1 = this.startDate
      if (!this.endDate1) this.endDate1 = this.endDate
      this.loading01 = true
       this.$api
          .post('/api/system/search/risk/record', {
            start_date: this.startDate1,
            end_date: this.endDate1,
            key_list: this.depapart_id,
            user_list: this.id,
            customer: this.customer,
            page: this.page
          })
          .then(res => {
            if (res.length === 0 || res.record_data.length === 0) {
              // this.$message.warning('暂无数据')
              this.loading01 = false
              this.isLoadOver = true
              // this.tableList = []
            } else {
              let table = []
              const associative_words = 'associative_words'
              table = res.record_data
              if (table.length >= 10) {
                table.forEach(k => {
                  k[associative_words] = k.key_word_data.associative_words
                  this.message_type.forEach(m => {
                    if (k.msg_type === m.value) {
                      k.message = m.label
                    }
                  })
                })
                this.tableList = this.tableList.concat(table)
                this.loading01 = false
                this.isLoadOver = false
              } else if (table.length < 10) {
                table.forEach(k => {
                  k[associative_words] = k.key_word_data.associative_words
                  this.message_type.forEach(m => {
                    if (k.msg_type === m.value) {
                      k.message = m.label
                    }
                  })
                })
                this.tableList = this.tableList.concat(table)
                this.loading01 = false
                this.isLoadOver = false
              } else {
                this.isLoadOver = false
                this.loading01 = false
            }
          }
        })
    },
    getChat1() {
      // this.loading01 = true
      this.$api
        .post('/api/system/search/risk/record/excel', {
          start_date: this.startDate1,
          end_date: this.endDate1,
          key_list: this.depapart_id,
          user_list: this.id,
          page: this.page
        })
        .then(res => {
          this.$message({
            message: '导出的文件请到菜单栏中的【下载中心】去下载',
            type: 'success'
          })
        })
    },
    timeRadioChange() {
      this.tableList = []
      this.tableData = []
      this.yData = []
      this.xData = []
      this.wordList = []
      this.wordNum = []
      this.page = 1
      this.depapart_id = []
      if (this.timeRadio === '近30天') {
        const date = this.$moment()
          .subtract('days', 30)
          .format('YYYY-MM-DD')
        this.startDate1 = this.startDate = date
        this.endDate1 = this.endDate = this.$moment()
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
        this.loadDate = date
      } else if (this.timeRadio === '近7天') {
        const date = this.$moment()
          .subtract('days', 7)
          .format('YYYY-MM-DD')
        this.startDate1 = this.startDate = date
        this.endDate1 = this.endDate = this.$moment()
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
        this.loadDate = date
      }
      this.scopeDate = []
      this.getList()
      this.getRisk()
      this.getData()
      this.getChat()
    },
    checkDate(date, label) {
      if (this.loading01) return true
      this.tableList = []
      this.startDate1 = date
      this.endDate1 = date
      const v = []
      this.word_list.forEach(k => {
        if (k.name_value === label) {
          v.push(k.key_id)
        }
      })
      this.page = 1
      this.depapart_id = v
      this.getChat()
     // window.scroll({ top: 1800, left: 0, behavior: 'smooth' })
    },
    gdfgf() {
      this.filterText = ''
      this.treeData01 = []
      // this.sfhusi()
    },
    onSearch() {
      this.timeRadio = ''
      this.yData = []
      this.xData = []
      this.wordList = []
      this.wordNum = []
      this.page = 1
      this.tableList = []
      this.depapart_id = []
      if (this.scopeDate === null || this.scopeDate.length === 0) {
        this.startDate1 = this.startDate = this.$moment().subtract(1, 'day').format('YYYY-MM-DD')
        this.endDate1 = this.endDate = this.$moment().subtract(1, 'day').format('YYYY-MM-DD')
        this.getList()
        this.getChat()
        this.getData()
        this.getRisk()
      } else {
        this.startDate1 = this.startDate = this.$moment(this.scopeDate[0]).format('YYYY-MM-DD')
        this.endDate1 = this.endDate = this.$moment(this.scopeDate[1]).format('YYYY-MM-DD')
        this.getList()
        this.getChat()
        this.getData()
        this.getRisk()
      }
    },
    search() {
      this.page = 1
      this.tableList = []
      this.getChat()
    },
    listLoad() {
      this.page += 1
      this.startDate = this.$moment(this.startDate).format('YYYY-MM-DD')
      this.endDate = this.$moment(this.endDate).format('YYYY-MM-DD')
      this.$api
        .post('/api/system/search/risk/ranking/data', {
            start_date: this.startDate,
            end_date: this.endDate,
            page: this.page
        })
        .then(res => {
          if (res) {
            const tableData = []
            let cloumns = []
            let itemLength = 0
            Object.keys(res.data).forEach((v, n) => {
              const nextItem = res.data[v]
              const valueList = []
              Object.keys(nextItem).forEach((k, n) => {
                cloumns.push({
                  title: nextItem[k].name,
                  prop: `data${n}`
                })
                valueList.push(nextItem[k].num)
                itemLength = Object.keys(nextItem).length
              })
              cloumns = cloumns.slice(0, itemLength)
              tableData.push({
                date: v,
                value: valueList
              })
          })
          this.cloumns = cloumns
          this.tableData = tableData.concat(tableData)
            this.page = this.page + 1
          } else {
            this.asLoadOver = true
          }
        })
    },
    listMore() {
      this.page = this.page + 1
      this.getChat()
     },
    // // 对话详情
    chatDetail(msgId, associative_words) {
      this.associative = associative_words
      this.dialogVisible = true
      this.msgId = ''
      // this.$api
      //   .post('/api/system/search/content/audit/details', {
      //     msg_id: msgId,
      //     type: 1,
      //     is_all: sessionStorage.getItem('isAll') || 1,
      //     page: 1,
      //     is_form: 3
      //   })
      //   .then(async res => {
          setTimeout(() => {
            this.dialogVisible = true
            this.msgId = msgId
          }, 200)
      //   })
    },
    strMark(str, mark) {
      let chars = []
      chars = mark.split(',')
      chars.forEach(k => {
        str = str.toString().replace(k, '<span style="color: red;">' + k + '</span>')
      })
      return str
    },
    // 风险列表
    nunExport() {
      var fix = document.querySelector('.el-table__fixed')
      var wb
      if (fix) {
        wb = XLSX.utils.table_to_book(document.querySelector('#educe-table').removeChild(fix))
        document.querySelector('#educe-table').appendChild(fix)
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector('#educe-table'))
      }
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'appliction/octet-stream' }),
          '风险列表.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },
    // 风险详情
    warnExport() {
      this.page = 1
      this.tableList = []
      this.getChat1()
    //   var table = document.querySelector('#ed-table').cloneNode(true)
    //   table.removeChild(table.querySelector('.el-table__fixed-right'))
    //   table.removeChild(table.querySelector('.el-table__fixed'))
    //   var wb = XLSX.utils.table_to_book(table, { raw: true })
    //   var wbout = XLSX.write(wb, {
    //     bookType: 'xlsx',
    //     book: true,
    //     type: 'array'
    //   })
    //   try {
    //     FileSaver.saveAs(
    //       new Blob([wbout], { type: 'appliction/octet-stream' }),
    //       '风险详情.xlsx'
    //     )
    //   } catch (e) {
    //     if (typeof console !== 'undefined') console.log(e, wbout)
    //   }
    //   return wbout
     },
    openSelectDialog() {
      this.isSelectDialog = true
      this.id = []
      this.searchForm.name = []
    },
    getAll() {
      const params = {
        page: 1,
        limit: 15
      }
      this.$api.get('/api/v1/inherit/get-department-user', params).then(response => {
        let res = response
        if (response && typeof response === 'string') {
          res = JSON.parse(response)
        }
        const treeData = res
        treeData.forEach(v => {
          v.label = v.name
          v.id = v.user_id
        })
        this.treeData = treeData || []
      })
    },
    setValueNull() {
      this.id = []
      this.searchForm.keyword = []
      this.parent_id = 0
      this.filterText = ''
      this.checkedDimission = []
      this.searchForm.name = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedEmployee = []
      this.sfhusi()
    },
     // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    getChecked(value, isCheck) {
      if (value.isDepartment === true && value.value) {
        const checkedDimission = this.checkedDimission
        if (isCheck === false) {
          checkedDimission.forEach((item, i) => {
            if (item.id === value.value) {
              checkedDimission.splice(i, 1)
            }
          })
          return false
        }
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedDimission.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedDimission.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedDimission = checkedDimission
      } else {
        this.checkedDimission.forEach(v => {
          this.peoples.push(v.id)
        })
        return false
      }
    },
    // 消息类型
    selectChange() {
      this.page = 1
      this.$api
        .get('/api/system/setting/message/type')
        .then(res => {
          this.message_type = res
        })
    },
    close() {
      this.isSelectDialog = false
      this.treeData = []
      this.name = ''
      this.filterText = ''
      this.peoples = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
    },
    reLoadTable() {
      if (this.checkedDimission.length > 0) {
          this.checkedDimission.forEach(v => {
          this.searchForm.name.push(v.name)
          this.id.push(v.id)
        })
        this.name = this.searchForm.name.toString()
        this.currentPage = 1
        this.isSelectDialog = false
      } else {
        this.$message.warning('请选择员工')
      }
    },
    // 获取敏感词表
    getWord() {
      this.$api.get('api/system/key/word/index').then(response => {
        const data = response.data
          data.forEach(v => {
            v.label = v.name
            v.value = v.id
          })
        this.departmentData = data
      })
    },
    getCode(item) {
      this.depapart_id = item
    },
    hruwih() {
      if (this.depapart_id.length === 0) {
        this.$message.warning('请先选择敏感词')
      } else {
        this.depapart_id.forEach(k => {
          this.departmentData.forEach(l => {
            if (k === l.id) {
              this.searchForm.keyword.push(l.name)
            }
          })
        })
        this.key_words = this.searchForm.keyword.toString()
        this.departmentShow3 = false
      }
    },
    ewqio() {
      this.departmentShow3 = false
      this.departmentData = []
      this.depapart_id = []
    },
    departmentShow() {
      this.departmentShow3 = true
      this.searchForm.keyword = []
      this.depapart_id = []
      this.checkList = []
      this.getWord()
    },
     getValueNull() {
      this.depapart_id = []
    },
    employeeClose(value) {
      this.checkedDimission.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedDimission.splice(i, 1)
          } else {
            this.checkedDimission.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    },
    dfhuh() {
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    clear() {
      this.parent_id = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card {
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(2, 47, 50, 0.1);
  opacity: 1;
  border-radius: 2px;
  overflow: auto;
  box-shadow: none;
}
::v-deep .el-dialog__body{
  padding: 0;
}
::v-deep .el-checkbox-group{
  margin: 1.25rem;
}
.ty-cont{
  display: flex;
  padding: 20px;
  align-items: center;
}
::v-deep .ty-card {
  position: relative;
  margin-bottom: 20px;
  .more-line {
    margin-top: 20px;
    text-align: center;
    color: #204a9e;
    cursor: pointer;
  }
  .wen{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    line-height: 31px;
    color: #303133;
    opacity: 1;
  }
  .zi {
    margin-left: 12px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);
    opacity: 1;
  }
}
.more {
  margin-top: -10px;
}
.el-icon-question {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 18px;
  color: #cbd0db;
}
.placeholder {
  opacity: 0.4;
}
::v-deep .el-dialog__header{
  background: #FFFFFF;
  box-shadow: 0px 2px 10px rgba(2, 47, 50, 0.08);
  opacity: 1;
  border-radius: 2p
  }
  ::v-deep .el-dialog .el-dialog__footer{
    text-align: right;
  }
::v-deep .el-radio-button__inner{
  border:1px solid #204a9e;
  color:#204a9e;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  border-left: 1px solid #204a9e;
  background-color: #204a9e;
  border-color: #204a9e;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  display: none;
}
::v-deep .el-select-dropdown{
  display: none;
}
::v-deep .el-select-dropdown__empty{
  display: none;
}
.cioji{
  height: 35px;
  width: 30px;
  background: #fff;
  position: relative;
  top: -58px;
  left: 85%;
  z-index: 99;
}
.cioji01{
  height: 35px;
  width: 30px;
  background: #fff;
  position: relative;
  top: -58px;
  left: 85%;
  z-index: 99;
}
::v-deep .el-dialog .el-dialog__body{
  border-top: 1px solid rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.02);
}
::v-deep .el-dialog__header {
  box-shadow: none;
}
::v-deep .el-range-editor.el-input__inner:hover{
  border-color: #234C9C;
}
::v-deep.el-radio-button:hover{
  opacity: 0.8;
}
.zi{
  font-size: 18px;
}
.weyqui{
  text-align: center;
}
::v-deep.el-button:hover{
  border-color: #fff;
}
::v-deep .el-card__header{
  border-bottom: none;
  box-shadow: none;
}
.infinite-listss{
  padding: 10px;
  margin: 0;
}
.dsfd{
  text-align:left;
  margin-top: 10px;
  margin-left: -20px;
}
.el-button--primary.is-disabled{
  opacity: 0.7;
 // background-color: red;
}
// ::v-deep .el-table__body{
//   height: 500px;
//   overflow: auto;
// }
.okm {
  display: -webkit-box;
  overflow: hidden;
  white-space: pre-wrap;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
// ::v-deep .el-table__fixed {
//   height: auto !important; // 此处的important表示优先于element.style
//   bottom: 18px; // 改为自动高度后，设置与父容器的底部距离，则高度会动态改变
// }
.sdfas{
  color: #204A9E;
}
.sdfas:hover{
  border-bottom: 1px solid #204A9E;
}
.corp-text {
  font-size: 14px;
  color: rgb(255, 200, 17);
}
.wx-text {
  font-size: 14px;
  color: #46bb36;
}
</style>
